import React from 'react';
import { GlobalUserDataProvider } from './GlobalUserData';

export const CombinedContextProvider: React.FC = ({ children }) => (
  <GlobalUserDataProvider>{children}</GlobalUserDataProvider>
);
